import React from "react";

import ReactDOM from 'react-dom';

const ProgressBar = ({ total, current }) => {

  const dots = [];
  for (let i = 0; i < total; i++) {
    const isActive = i <= current;
    dots.push(
      <React.Fragment key={i}>
        <div
          style={{
            width: 16,
            height: 16,
            borderRadius: "50%",
            backgroundColor: isActive ? "orange" : "#ccc",
            transition: "background-color 0.3s",
            zIndex: 2,
          }}
        />
        {i < total - 1 && (
          <div
            style={{
              flex: 1,
              height: 4,
              backgroundColor: i < current ? "orange" : "#ccc",
              margin: "0 4px",
              borderRadius: 2,
              transition: "background-color 0.3s",
              alignSelf: "center",
              zIndex: 1,
            }}
          />
        )}
      </React.Fragment>
    );
  }
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        maxWidth: 100,
        marginTop: 12,
        marginBottom: 12,
      }}
    >
      {dots}
    </div>
  );
};

const ModalCarrusel = ({ images, onClose }) => {
  const [index, setIndex] = React.useState(0);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);


  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!images || images.length === 0) return null;

  const nextImage = () => {
    setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevImage = () => {
    setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

 return ReactDOM.createPortal(
    <div
      onClick={handleBackgroundClick}
      style={{
      position: "fixed",   
      top: 0,
      left: 0,
      width: "100vw",   
      height: "100vh",    
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      padding: isMobile ? 10 : 20,
      }}
    >
      <div
        style={{
      backgroundColor: "white",
      paddingTop: 20,
      paddingBottom: 0,
      paddingLeft: 20,
      paddingRight: 20,
      borderRadius: 8,
      width: isMobile ? "95vw" : "80vw",
      height: isMobile ? "auto" : "80vh",       // altura fija solo en PC
      maxHeight: isMobile ? "90vh" : "none",    // maxHeight solo en móvil
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
        }}
      >
        <img
          src={images[index]}
          alt={`Imagen ${index + 1}`}
          style={{
            width: "100%",
            height: isMobile ? "auto" : "calc(100% - 60px)",
            maxHeight: "100%",
            objectFit: "contain",
            borderRadius: 4,
          }}
        />

        {/* Footer con barra y botones */}
        <div
          style={{
            marginTop: 5,
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <ProgressBar total={images.length} current={index} />

          <div>
            <button className="btn btn-secondary" onClick={prevImage} style={{ marginRight: 8 }}>
              Regresar
            </button>
            <button className="btn btn-primary" onClick={nextImage}>Siguiente</button>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default ModalCarrusel;